const formattedNPWP = (str: string): string => {
  return (str = str.replace(
    /(\d{1,2})(\d{1,3})(\d{1,3})(\d{1,1})(\d{1,3})(\d{1,3})/g,
    "$1.$2.$3.$4-$5.$6"
  ));
};
export default formattedNPWP;
